module.exports = __webpack_public_path__ + "media/video302.5a77dd6d.mp4";